import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { MenuStateModel } from 'src/app/model';
import { CloseMenu, OpenMenu, SetRegularMenuItems, SetAdminMenuItem } from './menu.actions';
import { regularMenuItems, adminMenuItem } from 'src/app/config';

@State<MenuStateModel>({
  name: 'isMenuOpen',
  defaults: {
    isMenuOpen: false,
    menuItems: [],
  },
})
@Injectable()
export class MenuState {
  @Selector()
  static isMenuOpen(state: MenuStateModel): boolean {
    return state.isMenuOpen;
  }

  @Selector()
  static menuItems(state: MenuStateModel): Array<any> {
    return state.menuItems;
  }

  @Action(OpenMenu)
  openMenu({ patchState }: StateContext<MenuStateModel>): void {
    patchState({
      isMenuOpen: true,
    });
  }

  @Action(CloseMenu)
  closeMenu({ patchState }: StateContext<MenuStateModel>): void {
    patchState({
      isMenuOpen: false,
    });
  }

  @Action(SetRegularMenuItems)
  setRegularMenuItems({ getState, patchState }: StateContext<MenuStateModel>): void {
    patchState({
      ...getState(),
      menuItems: regularMenuItems,
    });
  }

  @Action(SetAdminMenuItem)
  setAdminMenuItem({ getState, patchState }: StateContext<MenuStateModel>): void {
    patchState({
      ...getState(),
      menuItems: getState().menuItems.concat(adminMenuItem),
    });
  }
}
